module.exports = "precision highp float;\nvarying vec4 vertexColor;\nvoid main() {\ngl_FragColor = vertexColor;\n}"